import React from 'react';

const Connecticut = () => {
  return (
    <div>
      
    </div>
  );
}

export default Connecticut;
